import { useMemo } from 'react';

import { useInstantSearch, useRefinementList } from 'react-instantsearch';

import { useI18n } from '@change-corgi/core-react/i18n';

import {
	INSTANT_SEARCH_LOCATION_CITY_FILTER,
	INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER,
} from 'src/app/pages/search/shared/consts';

type Result = ModelHookResult<{
	selectedLocationFilterName: string;
	disabled: boolean;
	active: boolean;
}>;

export function useLocationMobileButton(): Result {
	const { translate } = useI18n();

	const { indexUiState } = useInstantSearch();
	const { canRefine } = useRefinementList({
		attribute: INSTANT_SEARCH_LOCATION_CITY_FILTER,
		limit: 30,
		operator: 'or',
	});

	const [locationSelected] =
		indexUiState.refinementList?.[INSTANT_SEARCH_LOCATION_CITY_FILTER] ||
		indexUiState.refinementList?.[INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER] ||
		[];

	const selectedLocationFilterName = useMemo(() => {
		if (locationSelected) {
			return locationSelected;
		}
		return translate('corgi.search.filters.location.title');
	}, [locationSelected, translate]);

	const disabled = !canRefine;

	return {
		data: {
			selectedLocationFilterName,
			disabled,
			active: !!locationSelected,
		},
	};
}
